import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import RudiAdditionalDocEdit from "../../components/services/additionalDoc/RudiAdditionalDocEdit";

const RudiAdditionalDocEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <RudiAdditionalDocEdit />
    </PageWrapper>
  );
};

export default RudiAdditionalDocEditPage;
